export const VISITA_STATUS = Object.freeze({
  SOLICITADA: 'solicitada',
  AGENDADA: 'agendada',
  CONFIRMADA: 'confirmada',
  PARALISADA: 'paralisada',
  REALIZADA: 'realizada',
  CANCELADA: 'cancelada',
  NAO_COMPARECEU: 'nao_compareceu',
  NAO_SUCEDIDA: 'nao_sucedida',
});

export const VISITA_ACTIVE_STATUSES = Object.freeze([
  VISITA_STATUS.SOLICITADA,
  VISITA_STATUS.AGENDADA,
  VISITA_STATUS.CONFIRMADA,
  VISITA_STATUS.PARALISADA,
]);

export const VISITA_STATUS_LABELS = Object.freeze({
  [VISITA_STATUS.SOLICITADA]: 'Aguardando confirmação',
  [VISITA_STATUS.AGENDADA]: 'Visita agendada',
  [VISITA_STATUS.CONFIRMADA]: 'Visita confirmada',
  [VISITA_STATUS.PARALISADA]: 'Finalização pendente',
  [VISITA_STATUS.REALIZADA]: 'Visita realizada',
  [VISITA_STATUS.CANCELADA]: 'Visita cancelada',
  [VISITA_STATUS.NAO_COMPARECEU]: 'Visita não realizada',
  [VISITA_STATUS.NAO_SUCEDIDA]: 'Visita não realizada',
});

export const VISITA_STATUS_CLASSES = Object.freeze({
  [VISITA_STATUS.SOLICITADA]: 'text-amber-700 bg-amber-50',
  [VISITA_STATUS.AGENDADA]: 'text-sky-700 bg-sky-50',
  [VISITA_STATUS.CONFIRMADA]: 'text-emerald-700 bg-emerald-50',
  [VISITA_STATUS.PARALISADA]: 'text-amber-700 bg-amber-50',
  [VISITA_STATUS.REALIZADA]: 'text-emerald-700 bg-emerald-50',
  [VISITA_STATUS.CANCELADA]: 'text-rose-700 bg-rose-50',
  [VISITA_STATUS.NAO_COMPARECEU]: 'text-rose-700 bg-rose-50',
  [VISITA_STATUS.NAO_SUCEDIDA]: 'text-amber-700 bg-amber-50',
});

export const HOUSE_OCCUPANCY = Object.freeze({
  EMPTY: 'vazio',
  OWNER: 'proprietario',
  TENANT: 'inquilino',
  THIRD_PARTY_TENANT: 'inquilino_terceiro',
});

export const HOUSE_OCCUPANCY_LABELS = Object.freeze({
  [HOUSE_OCCUPANCY.EMPTY]: 'Imóvel vazio',
  [HOUSE_OCCUPANCY.OWNER]: 'Ocupado pelo proprietário',
  [HOUSE_OCCUPANCY.TENANT]: 'Ocupado por inquilino',
  [HOUSE_OCCUPANCY.THIRD_PARTY_TENANT]: 'Ocupado por inquilino de terceiro',
});

export const HOUSE_CONTACT_ROLES = Object.freeze({
  LANDLORD: 'LANDLORD',
  TENANT: 'TENANT',
  CIQ: 'CIQ',
  LISTING_REPRESENTATIVE: 'LISTING_REPRESENTATIVE',
  CLIENT: 'CLIENT',
});

export {
  QA_ACTOR_ROLE_MAP as ACTOR_ROLE_MAP,
  QA_CANCELLATION_REASON_BY_REFERENCE as CANCELLATION_REASON_BY_REFERENCE,
  QA_HOUSE_OCCUPANCY_BY_REFERENCE as HOUSE_OCCUPANCY_BY_REFERENCE,
  QA_USER_TYPE_MAP as USER_TYPE_MAP,
  normalizeQaHouseOccupancy as normalizeHouseOccupancy,
} from './quintoAndarParity';

export default VISITA_STATUS;
